<script setup lang="ts">
defineProps<{
  suffix?: string;
}>();
</script>

<template>
  <ProductSidebarUSP>
    <template #icon>
      <img
        :src="`/icons/fabricks-logo${suffix ?? ''}.svg`"
        alt="Fabricks logo"
        width="24px"
        height="24px"
      />
    </template>
    <template #title>
      {{ $t("bidProductSidebar.fabricks.title") }}
    </template>
    <template #description>
      {{ $t("bidProductSidebar.fabricks.description") }}
    </template>
  </ProductSidebarUSP>
</template>
